// src/components/ImageDiagnosis.js
import React, { useState, useRef } from 'react';
import * as mobilenet from '@tensorflow-models/mobilenet';
import '@tensorflow/tfjs';

const ImageDiagnosis = () => {
  const [imagePreview, setImagePreview] = useState(null);
  const [prediction, setPrediction] = useState('');
  const imageRef = useRef();

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageURL = URL.createObjectURL(file);
      setImagePreview(imageURL);
      setPrediction('Analyzing...');

      const img = new Image();
      img.src = imageURL;
      img.crossOrigin = 'anonymous';

      img.onload = async () => {
        try {
          const model = await mobilenet.load();
          const predictions = await model.classify(img);

          if (predictions.length > 0) {
            setPrediction(
              `Looks like: ${predictions[0].className} (${Math.round(predictions[0].probability * 100)}%)`
            );
          } else {
            setPrediction('Could not identify the issue.');
          }
        } catch (error) {
          console.error(error);
          setPrediction('❌ Something went wrong during diagnosis.');
        }
      };

      img.onerror = () => {
        setPrediction('❌ Failed to load the image.');
      };
    }
  };

  return (
    <div className="diagnosis-section white-theme">
      <h2>🧠 AI Image Diagnosis</h2>
      <input type="file" accept="image/*" onChange={handleImageUpload} />
      {imagePreview && (
        <div>
          <img
            ref={imageRef}
            src={imagePreview}
            alt="Uploaded preview"
            style={{ maxWidth: '300px', marginTop: '10px' }}
            crossOrigin="anonymous"
          />
          <p style={{ color: 'white' }}>
            <strong>Prediction:</strong> {prediction}
          </p>
        </div>
      )}
    </div>
  );
};

export default ImageDiagnosis;
